import { useState, useEffect, useMemo, forwardRef } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  ListSubheader,
  TextField,
  InputAdornment,
} from '@mui/material';
import { getAllProjects } from 'src/services/projectDetailService';
import SearchIcon from '@mui/icons-material/Search';

interface ProjectMultiSelectProps {
  value: string | string[] | [],
  onChange: (e: any) => void,
}

const ProjectMultiSelect = forwardRef((props: ProjectMultiSelectProps, _ref) => {
  const [projects, setProjects] = useState<any>([]);
  const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
  const [searchText, setSearchText] = useState<string>('');

  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  useEffect(() => {
    const fetchProject = () => {
      getAllProjects().then((res) => {
        setProjects((res.data.filter(e => !e.isClosed) as any[]) || []);
      });
    }

    fetchProject();
  }, []);

  const filteredProjects = useMemo(
    () =>
      projects.length > 0 &&
      projects?.filter((option) => containsText(option?.name, searchText)),
    [projects, searchText]
  );

  useEffect(() => {
    const projectsSelectedName = [];
    if(props?.value && props?.value.length > 0){
      for(let i=0; i < props?.value.length; i++){
        const result = projects.filter(e => e.id.toString() === props?.value[i]);
        projectsSelectedName.push(result[0].name);
      }
    }
    setSelectedProjects(projectsSelectedName);
  }, [projects, props?.value]);

  return (
    <FormControl fullWidth>
      <InputLabel
        style={{
          fontSize: '12px'
        }}
      >
        Project Name
      </InputLabel>
      <Select
        id="filter-project"
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        multiple
        size="small"
        value={props?.value}
        renderValue={() => selectedProjects.join(', ')}
        onChange={(e) => props?.onChange(e)}
        onClose={() => setSearchText('')}
      >
        <ListSubheader>
          <TextField
            id="search-stakeholderRole"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>
        {
          filteredProjects?.length > 0 &&
          filteredProjects.map((project, i) => {
            return (
              <MenuItem key={project?.id} 
                value={project?.id}>
                  <Checkbox checked={props?.value.indexOf(project?.id as never) > -1} />
                  <ListItemText primary={project?.name} />
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default ProjectMultiSelect;
